import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {Card} from '~/components/general/card/Card'
import {Typography} from '~/components/general/typography/Typography'

export const StatsContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 70vh;
  overflow-y: auto;
`

export const EditableCard = styled(Card)`
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f9fafb;
`

export const DepartmentSection = styled(Container)`
  margin-bottom: 1.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`

export const InputRow = styled(Container)`
  margin-bottom: 1rem;
`

export const StatsCard = styled(Card)`
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`

export const StatsRow = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
`

export const StatsGrid = styled(Container)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin-top: 1rem;
`

export const StatsGridFourColumns = styled(Container)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  margin-top: 1rem;
`

export const StatItem = styled(Container)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.25rem 0;
  gap: 0.25rem;
`

export const SectionTitle = styled(Typography)`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`

export const EditableSectionTitle = styled(Typography)`
  margin-bottom: 1rem;
`

export const DepartmentTitle = styled(Typography)`
  margin-bottom: 0.75rem;
`

export const FieldLabel = styled(Typography)`
  margin-bottom: 0.25rem;
`

export const SubmitButtonContainer = styled(Container)`
  margin-top: 1rem;
  padding: 0 1rem 1rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`
